var React = require('react');

function AngleRightRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"}));
}

AngleRightRegular.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"angle-right","className":"svg-inline--fa fa-angle-right fa-w-6","role":"img","viewBox":"0 0 192 512"};

module.exports = AngleRightRegular;

AngleRightRegular.default = AngleRightRegular;
